<template>
    <rkm-area title="Desfecho">
        <Form :model="model" />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        model: { type: Object, required: true },
    }
}
</script>